@if (Scope.onLinkTextChange() && useSchoolName) {
    <h5 class="sb-navigation-text">
        <ng-content></ng-content>
    </h5>
}

@if (!useSchoolName || !Scope.onLinkTextChange()) {
    <div class="sb-sidebar-logo">
        <img class="sb-navigation-logo-full" src="assets/app-logoV2026-10-23.svg" [alt]="logoAlt" />
        <img class="sb-navigation-logo-icon" src="assets/app-logo-iconV2026-10-23.svg" alt="" aria-hidden="true" />
    </div>
}
